// Supabase client singleton
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY as string;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export interface Profile {
  id: string;
  name: string;
  email: string;
  plan: string;
  module_0_unlocked: boolean;
  modules_unlocked: number[];
  motivation: string;
  created_at: string;
  updated_at: string;
}
